// src/Profile.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    mobile: ""
  });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");

    if (!token) {
      navigate("/login");
      return;
    }

    fetch("https://teamo.co.za/api/users/profile", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch profile");
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setFormData({
          name: data.name || "",
          surname: data.surname || "",
          email: data.email || "",
          mobile: data.mobile || ""
        });
      })
      .catch((err) => {
        console.error("Profile fetch error:", err);
        navigate("/login");
      });
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    const token = localStorage.getItem("authToken");

    fetch("https://teamo.co.za/api/users/profile", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.message) {
          setMessage("Profile updated successfully.");
          setTimeout(() => navigate("/"), 1500); // Redirect to home
        } else {
          setMessage("Failed to update profile.");
        }
      })
      .catch((err) => {
        console.error("Update error:", err);
        setMessage("An error occurred while updating profile.");
      });
  };

  const handleCancel = () => {
    navigate("/"); // Go back to home on cancel
  };

  const handleDeleteAccount = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete your account? This cannot be undone.");

    if (!confirmDelete) return;

    const token = localStorage.getItem("authToken");

    fetch("https://teamo.co.za/api/users/delete-account", {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Account deletion failed");
        return res.json();
      })
      .then(() => {
        localStorage.removeItem("authToken");
        alert("Your account has been deleted.");
        navigate("/login");
      })
      .catch((err) => {
        console.error("Account deletion error:", err);
        setMessage("Failed to delete account.");
      });
  };

  return (
    <div style={{ maxWidth: "400px", margin: "100px auto", textAlign: "center" }}>
      <h2>Profile</h2>
      {user ? (
        <form onSubmit={handleUpdate}>
          <input
            type="text"
            name="name"
            placeholder="First Name"
            value={formData.name}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px", margin: "8px 0" }}
          />
          <input
            type="text"
            name="surname"
            placeholder="Surname"
            value={formData.surname}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px", margin: "8px 0" }}
          />
          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px", margin: "8px 0" }}
          />
          <input
            type="text"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
            style={{ width: "100%", padding: "8px", margin: "8px 0" }}
          />

<button
  type="submit"
  style={{
    padding: "6px 12px",
    backgroundColor: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    marginRight: "10px",
  }}
>
  Save Changes
</button>

<button
  type="button"
  onClick={handleCancel}
  style={{
    padding: "6px 12px",
    backgroundColor: "#6c757d",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    marginRight: "10px",
  }}
>
  Cancel
</button>

<button
  type="button"
  onClick={handleLogout}
  style={{
    padding: "6px 12px",
    backgroundColor: "#dc3545",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
    marginRight: "10px",
  }}
>
  Logout
</button>

<button
  type="button"
  onClick={handleDeleteAccount}
  style={{
    padding: "6px 12px",
    backgroundColor: "#bd2130",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    marginTop: "10px",
  }}
>
  Delete Account
</button>

          {message && <p style={{ marginTop: "10px", color: "green" }}>{message}</p>}
        </form>
      ) : (
        <p>Loading profile...</p>
      )}
    </div>
  );
};

export default Profile;
